import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import axios from "axios";

const AddNewMasterTable = () => {
  const [newTableName, setNewTableName] = useState(""); // Table Name
  const [columns, setColumns] = useState([
    {
      columnName: "",
      dataType: "text",
      maxLength: "",
      isNullable: true,
      isPrimaryKey: false,
    },
  ]);

  // Add a new column to the form
  const addColumn = () => {
    setColumns([
      ...columns,
      {
        columnName: "",
        dataType: "text",
        maxLength: "",
        isNullable: true,
        isPrimaryKey: false,
      },
    ]);
  };

  // Remove a column from the form
  const removeColumn = (index) => {
    setColumns(columns.filter((_, i) => i !== index));
  };

  // Update column details when inputs are changed
  const updateColumn = (index, field, value) => {
    const updatedColumns = columns.map((col, i) =>
      i === index ? { ...col, [field]: value } : col
    );
    setColumns(updatedColumns);
  };

  // Submit the table creation form to backend
  const createNewTable = async () => {
    const newTableData = {
      tableName: newTableName,
      columns: columns,
    };
    console.log("new table data", newTableData);

    try {
      //   await axios.post("/tables/create", newTableData);
      //   alert("Table created successfully!");
    } catch (error) {
      console.error("Error creating table", error);
      alert("Error creating table. Check console for more details.");
    }
  };

  return (
    <Box display="flex" flexDirection={"column"} gap={2} sx={{ p: 3 }}>
      <Box>
        <Typography variant="h4">Create New Master Table</Typography>

        {/* Input for the new table name */}
        <TextField
          sx={{ width: "40%" }}
          size="small"
          label="Table Name"
          value={newTableName}
          onChange={(e) => setNewTableName(e.target.value)}
          margin="normal"
          required
        />
      </Box>

      <Typography variant="h5">Define Columns</Typography>

      {/* Dynamic form to add columns */}
      {columns.map((col, index) => (
        <Box
          key={index}
          sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}
        >
          {/* Column Name */}
          <TextField
            size="small"
            label="Column Name"
            value={col.columnName}
            onChange={(e) => updateColumn(index, "columnName", e.target.value)}
            fullWidth
            required
          />

          {/* Data Type */}
          <FormControl fullWidth>
            <InputLabel>Data Type</InputLabel>
            <Select
              size="small"
              value={col.dataType}
              onChange={(e) => updateColumn(index, "dataType", e.target.value)}
              label="Data Type"
              required
            >
              <MenuItem value="text">Text</MenuItem>
              <MenuItem value="integer">Integer</MenuItem>
              <MenuItem value="boolean">Boolean</MenuItem>
              <MenuItem value="date">Date</MenuItem>
              <MenuItem value="float">Float</MenuItem>
              {/* Add more types if needed */}
            </Select>
          </FormControl>

          {/* Max Length for applicable types */}
          {col.dataType === "text" && (
            <TextField
              size="small"
              label="Max Length"
              type="number"
              value={col.maxLength}
              onChange={(e) => updateColumn(index, "maxLength", e.target.value)}
              fullWidth
            />
          )}

          {/* Nullable Checkbox */}
          <FormControlLabel
            control={
              <Checkbox
                checked={col.isNullable}
                onChange={(e) =>
                  updateColumn(index, "isNullable", e.target.checked)
                }
              />
            }
            label="Nullable"
          />

          {/* Primary Key Checkbox */}
          <FormControlLabel
            control={
              <Checkbox
                checked={col.isPrimaryKey}
                onChange={(e) =>
                  updateColumn(index, "isPrimaryKey", e.target.checked)
                }
              />
            }
            label="Primary Key"
          />

          {/* Remove Column Button */}
          {columns.length > 1 && (
            <Button color="error" onClick={() => removeColumn(index)}>
              Remove
            </Button>
          )}
        </Box>
      ))}

      {/* Button to add a new column */}
      <Box>
        <Button onClick={addColumn} variant="outlined" sx={{ mb: 2 }}>
          Add Column
        </Button>
      </Box>

      {/* Submit the form to create the table */}
      <Box>
        <Button onClick={createNewTable} variant="contained" color="primary">
          Create Table
        </Button>
      </Box>
    </Box>
  );
};

export default AddNewMasterTable;
